import React, { useEffect, useState, useMemo } from 'react';
import { CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import {sortBy} from 'lodash';

function FixedTags(props) {
  return (
    <div className="fixed_tags" ><h4>Filtrar por Tags</h4></div>
  )
}

const Tags = (params) => {
  const location = params.location;
  const selecionado = params.selecionado;
  const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;

  const url = useMemo(() => `${baseUrl}/content/tags`, [baseUrl]);
  const requestHeaders = useMemo(() => {
    const headers = new Headers();
    headers.append("X-Frontend-Client", "react-app");
    return headers;
  }, []);
  const [tags, setTags] = useState([]);
  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    fetch(url, {
      method: 'GET',
      headers: requestHeaders
      })
      .then((response) => response.json())
      .then((result) => {
        setTags(result);
        setLoading(false);
      });
  }, [isLoading, url, requestHeaders]);
  if (isLoading) {
    return <Box className="tags"><FixedTags /><CircularProgress className="loading" /></Box>;
  }
return (<div>
  <Box className="tags">
  <FixedTags />
<ul className="cards" sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
  <Link to={`/${location}`}><button className={selecionado === "todos" ? "selecionado": ""}>Todos</button></Link>
    {sortBy(Object.entries(tags), 'titulo').map(([key, value]) => (
      <Link key={value.id} to={`/${location}/${key}`}><button className={selecionado === key ? "selecionado": ""}>{value.titulo}</button></Link>))
    }
  </ul></Box>
  </div>
)
};

export default Tags;